import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/core/authentication/authentication.service';

@Component({
  selector: 'in-active-page',
  templateUrl: './in-active-page.component.html',
  styleUrls: ['./in-active-page.component.scss']
})
export class InActivePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
